(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  // Select the element
const btn = document.querySelector('.button.button--primary.button--md.icon-with-text:last-child');

if (btn) {
  // Check if it has an href attribute
  if (btn.hasAttribute('href') && btn.getAttribute('href').trim() !== "") {
    btn.style.display = 'inline-flex'; // Show if href exists
  } else {
    btn.style.display = 'none';   // Hide if no href
  }
}

  } catch(e) { console.error(e); }
})();
})();
